import { createFileRoute, useParams } from '@tanstack/react-router'
import VisualsGallery from '../../../../../../../../../../../../../containers/pin-details/components/media-and-files/pin-visual-media/visuals-gallery'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId/'
)({
  component: PinDetailsAllVisualsGalleryRoute
})

function PinDetailsAllVisualsGalleryRoute() {
  const { fileId } = useParams({ strict: false })
  return <VisualsGallery fileId={fileId} />
}
